import React from 'react';

import './Header.css';

//const logo = require('../assets/img/logo_sfp_light.png');
import logo from '../assets/img/logo_sfp_light.png'

const Header = () => (
    
    <nav className="Titulo navbar navbar-expand-lg d-flex justify-content-center mb-4">
	
		<div>
		
		    <img src={logo}
				alt="Secretaría de la Función Pública"
				style={{ width: `35%` }}
			/>
            
        </div>
		
		<div>
		
		    <h3>
                Encuesta de Clima y Cultura Organizacional
            </h3>   
            
        </div>
		
    </nav>
);

export default Header;
